import { Select, Typography } from '@material-ui/core';
import { StyleSheet } from '@react-pdf/renderer';
import SahamDialog from 'components/SahamDialog';
import { isNil } from 'lodash';
import styled from 'styled-components';
import { COLORS } from 'constants/design';
import {
  BORDER_COLOR,
  BORDER_STYLE,
} from 'containers/CourtManagerLegalProceedings/Provision/Regulation/constants';

interface StyleRegulationFormProps {
  showSideRecap: boolean;
}
export const styles = StyleSheet.create({
  page: {
    width: '100%',
    flexDirection: 'column',
    backgroundColor: 'white',
    fontFamily: 'Roboto',
    fontWeight: 'normal',
    fontSize: 10,
    marginTop: 35,
    marginBottom: 25,
  },
  tableCol: {
    borderStyle: BORDER_STYLE,
    borderColor: BORDER_COLOR,
    borderBottomColor: '#000',
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
  },
  section: {
    margin: '0px 10px 0px 10px',
    padding: '0px 10px 0px 10px',
  },
  finalsection: {
    padding: '0px 20px 0px 20px',
    margin: '0px 20px 0px 20px',
  },
  arabicColumn: {
    width: '40%',
    lineHeight: 0,
    alignItems: 'center',
    flexDirection: 'column',
  },
  arabicElements: {
    width: '40%',
    lineHeight: 0,
    alignItems: 'center',
    padding: 5,
  },
  rowColumn: {
    justifyContent: 'space-between',
    flexGrow: 1,
    width: '100%',
    flexDirection: 'row-reverse',
  },
  arabicItem: {
    width: '20%',
    alignItems: 'center',
    justifyContent: 'flex-start',
  },
  tableElem: {
    flexDirection: 'row-reverse',
  },
  checkboxContainer: {
    flexDirection: 'row-reverse',
    alignItems: 'center',
  },
  checkbox: {
    width: 10,
    height: 10,
    borderStyle: BORDER_STYLE,
    borderColor: BORDER_COLOR,
    backgroundColor: 'white',
    borderWidth: 1,
  },
  frenchColumn: {
    width: '60%',
    alignItems: 'center',
    flexDirection: 'column',
  },
  row: {
    display: 'flex',
    flexGrow: 1,
    flexDirection: 'row',
  },
  column: {
    display: 'flex',
    flexGrow: 1,
    flexDirection: 'column',
  },
  text: {
    fontFamily: 'NotoSansArabic',
  },
  arabicText: {
    fontFamily: 'NotoArabic',
  },
  cnraArabicText: {
    fontFamily: 'NotooArabic',
  },
  headerBg: {
    backgroundColor: 'white',
  },
  table: {
    borderStyle: BORDER_STYLE,
    borderColor: BORDER_COLOR,
    backgroundColor: 'white',
    borderWidth: 1,
    margin: '0px 20px 0px 60px',
  },
  tableRow: {
    flexDirection: 'row',
  },
  tableWidth: {
    width: '50%',
    padding: 5,
  },
  textCenter: {
    textAlign: 'center',
  },
  withUnderline: {
    textDecoration: 'underline',
  },
  withBorder: {
    border: '1.5px solid black',
    margin: 2,
    fontFamily: 'Roboto',
    alignSelf: 'center',
    alignContent: 'center',
    textAlign: 'center',
    width: '100%',
    lineHeight: 1,
  },
  textBorder: {
    border: '1.5px solid black',
    padding: '3px 7px',
    fontFamily: 'Roboto',
    alignSelf: 'center',
    alignContent: 'center',
    textAlign: 'center',
    lineHeight: 1,
    justifyContent: 'flex-start',
  },
  withBottomBorder: {
    borderBottom: '1px solid black',
    lineHeight: 1,
    width: '100%',
  },
  withTopBorder: {
    borderTop: '1px solid black',
    lineHeight: 1.2,
    width: '100%',
    margin: '0px 3px 0px 3px',
    paddingTop: 3,
    textAlign: 'right',
    fontStyle: 'italic',
    fontWeight: 'bold',
  },
  boldText: {
    fontWeight: 'bold',
  },
  borderColumn: {
    alignItems: 'flex-start',
  },
  italicText: {
    fontWeight: 300,
    fontStyle: 'italic',
  },
  bloc: {
    padding: '10px 10px 0px 10px',
    marginLeft: 10,
    marginRight: 10,
  },
  item: {
    padding: '0px 5px 0px 5px',
  },
  uppercase: { textTransform: 'uppercase' },
});
export const StyleRegulationForm = styled.div<StyleRegulationFormProps>`
  box-sizing: border-box;
  margin-top: 10px;
  width: ${({ showSideRecap }) => (showSideRecap ? '680px' : 'auto')};
  border-bottom: 1px solid #e1e1e1;
  border-radius: 10px 0px 0px 0px;
  .content {
    background: ${({ showSideRecap }) =>
      showSideRecap ? '#00194d' : '#0074c9'};
    height: 61px;
    border-bottom: 1px solid rgb(225, 225, 225);
    border-radius: 10px 0px 0px;
  }
  .title {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 700;
    font-size: 20px;
    line-height: 50px;
    letter-spacing: 0.02em;
    color: #ffffff;

    margin-left: 25px;
  }
  .beneficiary {
    margin: 5px;
    padding-left: 10px;
    border-radius: 4px;
    align-content: flex-start;
    height: auto;
    padding: 10px;
    width: 100%;
    border: 1px solid #ebeef1;
    border-radius: 8px;
  }
  .beneficiary-name {
    padding: 0 10px 10px 10px;
    min-width: 92px;
    font-size: 14px;
    font-weight: bold;
    color: #577083;
    text-transform: uppercase;
  }
  .data-info {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 500;
    font-size: 21px;
    line-height: 50px;
    letter-spacing: 0.02em;
  }
`;
interface RegulationRecapContainerProps {
  height: number | null;
}
export const RegulationRecapContainer = styled.div<
  RegulationRecapContainerProps
>`
  box-sizing: border-box;
  margin-top: 10px;
  height: ${({ height }) => (!isNil(height) ? `${height}px` : '100%')};
  width: 100%;
  border-bottom: 1px solid #e1e1e1;
  border-radius: 0px 10px 0px 0px;
  overflow-y: scroll;
  .recap-title {
    background: #0074c9;
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 700;
    height: 60px;
    font-size: 20px;
    line-height: 50px;
    letter-spacing: 0.02em;
    color: #ffffff !important;
    padding-left: 25px;
  }
`;

export const RecapContainer = styled.div`
  margin-right: 10px;
  display: flex;
  .no-data {
    width: 100%;
    text-align-last: center;
  }
  .side-recap {
    align-items: center;
    flex-direction: column;
    width: 100%;
  }
  .box-field {
    padding: 8px;
    border-radius: 8px;
    border: 1px solid #ebeef1;
    margin-bottom: 20px;
  }
  .victim-el {
    padding-bottom: 10px;
    display: block;
    font-size: 13px;
    font-weight: 500;
    color: #8b8b8b;
  }
  .beneficiary-items {
    padding-top: 10px;
  }
  deceased-victim {
    padding-bottom: 5px;
  }

  .item-row {
    align-items: center;
    flex-direction: row;
    display: flex;
  }
  .item {
    font-size: 13px;
    font-weight: 500;
    font-family: 'Roboto';
    font-style: normal;
    margin: 5px;
  }
`;
interface RegulationHeaderProps {
  showSideRecap: boolean;
}
export const RegulationHeader = styled.div<RegulationHeaderProps>`
  display: ${({ showSideRecap }) => (showSideRecap ? 'flex' : 'contents')};
  width: 100%;
  background: #ffffff;
  border-radius: 10px;
`;
export const ContainerRegulation = styled.div``;
export const ProvisionContainer = styled.div`
  .intervenant-item {
    color: #0880bc !important;
    font-weight: 700;
    width: 30%;
  }
  .item-types {
    flex-direction: column;
    padding-bottom: 20px;
    width: 100%;
    display: inline-block;
  }
  .item-row {
    align-items: center;
    flex-direction: row;
    display: flex;
    width: 100%;
    padding: 8px;
  }
  .provision-content {
    width: 100%;
    align-self: center;
  }
`;
export const RiskContainer = styled.div`
  margin-left: 10px;
  padding-top: 5px;
  border-right: 1px solid #dddddd;
  box-shadow: -4px 0px 5px -4px rgba(0, 0, 0, 0.05);
  margin-top: 10px;
  .unshow-sheet {
    display: none;
  }
  .title {
    padding-top: 20px;
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 19px;
    letter-spacing: 0.02em;
    color: #000000;
  }
  .recap-title {
    padding-bottom: 10px;
    color: rgba(9, 122, 194, 1);
  }
  .secondaryTitle {
    display: block;
    margin-left: 25px;
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 19px;
    letter-spacing: 0.02em;
    color: #8e8e8e;
    margin-top: 10px;
  }
  .item-types {
    flex-direction: column;
    padding-bottom: 20px;
    width: 100%;
    display: inline-block;
  }
  .item-columns {
    display: flex;
    flex-direction: column;
    margin-right: 10px;
    width: 50%;
  }

  .item-rows {
    display: flex;
    flex-direction: row;
  }
  .item {
    padding: 10px 0px 5px 0px;
    width: 100%;
  }
  .risk-content {
    width: 100%;
    border-radius: 4px;
    box-shadow: 0px 1px 3px #0000001f;
    padding: 16px;
    display: contents;
  }
  .MuiAccordionDetails-root {
    display: block;
    padding: 8px 16px 16px;
  }
  .action-button {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding: 20px;
    width: 100%;
    color: #fff;
  }
  .validate {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 19px;
    color: #fff;
    cursor: pointer;
  }
`;
export const RiskName = styled.div`
  width: 300px;
  color: #000;
  height: 50px;
  padding-top: 15px;
  padding-left: 10px;
  background: #fff;
  border: 1px solid #000;
  border-radius: 4px;
  margin-top: 10px;
  font-weight: bold;
  cursor: pointer;
`;

export const RiskNameWrapper = styled.div`
  margin-left: 20px;
  margin-top: 20px;
  .activeButton {
    background-color: #162952;
    color: #fff;
  }
  .content-item {
    width: 100%;
    padding-left: 16px;
    padding-top: 8px;
    background-color: #f4f4f4;
    border-radius: 4px;
    line-height: 1px;
  }
  .beneficiary-item {
    flex-wrap: wrap;
    position: relative;
    max-width: 50%;
  }
  .title {
    min-width: 92px;
    font-size: 14px;
    font-weight: bold;
    color: #0072c6;
    text-transform: uppercase;
    align-self: center;
    line-height: 1px;
  }
`;
export const StyledDiv = styled.div`
  .input {
    width: 100%;
    margin-right: 24px;
    margin-top: 12px;
  }
  .jom-validation {
    padding: 10px;
    color: red;
  }
  .judgement-date {
    align-self: center;
    margin-top: 15px;
  }
  .other-item {
    align-self: end;
  }
`;

export const StyledSelect = styled(Select)`
  &.MuiInput-underline.Mui-disabled:before {
    border-bottom-style: solid;
  }
  .MuiSelect-icon {
    color: black;
  }
  font-weight: 500;
  width: 500px;
`;
export const Dialog = styled(SahamDialog)`
  .MuiDialogContent-root .content {
    background-color: skyblue;
    font-size: 18px;
    min-width: 316px;
  }
  .info-message {
    padding: 10px 0;
    font-style: italic;
    font-size: 12px;
  }
  .header {
    display: flex;
    justify-content: space-between;
  }
  .details {
    display: 'flex',
    flexDirection: 'row',
  }
  
  .jom-info { padding-right:15px}
`;

export const Title = styled(Typography)`
  text-align: left;
  color: #8b8b8b;
  font-weight: 500;
  font-size: 13px;
  .MuiSvgIcon-fontSizeSmall {
    font-size: 1rem;
    margin-bottom: -3px;
  }
`;
export const Field = styled(Typography)`
  text-align: left;
  font-weight: 500;
  font-size: 13px;
`;

export const StyledCard = {
  backgroundColor: COLORS.LIGHT_ORANGE,
  padding: '8px 16px 8px 8px',
  marginBottom: 10,
};

export const StyledText = {
  color: COLORS.ORANGE_TEXT,
  fontSize: '14px',
  fontWeight: 500,
};
